export const FAQS = [
  {
    q: "Does a website review cost anything?",
    rev: true,
    a: "No. The initial review is free and there's no obligation. Send us your website address, and within one business day you get a plain-English list of what we'd change. You only pay if you decide to go ahead with the work.",
  },
  {
    q: "Will my website platform work with your improvements, or do I need a rebuild?",
    rev: true,
    a: "That's exactly what the review tells you. Some platforms we can improve in place; others are too locked down or too outdated to change safely. We check what your site is built on first and tell you honestly which it is — improve in place, or rebuild — rather than selling you the bigger job by default.",
  },
  {
    q: "How are improvement projects priced?",
    rev: true,
    a: "Each project gets a flat quote after the free review, based on the specific work you want done. We don't publish hourly rates or package prices for improvements, because a mobile layout fix and a full content rebuild aren't the same job. You see the scope and the price before any work starts.",
  },
  {
    q: "Do I have to sign up for monthly management afterward?",
    rev: true,
    a: "No. A one-time improvement project is completely fine — we do the work, you own the result, and that's the end of it. Ongoing management is optional and agreed separately if you want it. The $499 build plus $79/month managed plan stays its own separate offer.",
  },
  {
    q: "Can you improve the website I already have?",
    rev: true,
    a: "Yes. We can refresh the design, fix how it looks and works on phones, add service pages or galleries, update your content, and simplify how customers request a quote. The initial review is free, each project is quoted individually after we check your site and the platform it's built on, and ongoing management is optional and agreed separately. Send us your link and ask for a website review.",
  },
  {
    q: "What are the quote and call automations, exactly?",
    rev: true,
    a: "There are three, and they're separate from each other. (1) Text alerts to you the moment a new quote request arrives, so you see it without checking email. (2) Automatic email and text acknowledgments to the customer who submitted the request, confirming you received it. (3) Missed-call text backs, which text a caller automatically when you can't pick up. Acknowledgments confirm receipt only — they don't send a calculated price or book a confirmed appointment, which is separate functionality we'd agree on first.",
  },
  {
    q: "Can the automations run on a website you didn't build?",
    rev: true,
    a: "Often, yes. They can be installed on a WebJesters-built site or on a compatible existing website, but it depends on your current forms and phone setup — so we check compatibility first and confirm what's possible before quoting. Each automation is optional and quoted individually; none of them are included in the standard plans.",
  },
  {
    q: "How much does a WebJesters website cost?",
    home: true,
    a: "The website plan is $499 one-time to build plus $79/month to host and manage it. A $99 deposit reserves your build slot and is credited toward the build fee, the remaining build balance is due before launch, and the monthly fee starts once your site goes live. Month-to-month, cancel anytime.",
  },
  {
    q: "What's included in the $79/month?",
    home: true,
    a: "Hosting, SSL and domain setup, security patches, backups and uptime monitoring, instant lead alerts to your email, a private client portal with lead tracking, and reasonable minor ongoing updates. New pages, advanced features, or structural redesigns are quoted separately. Quote and call automations are optional and quoted individually — they aren't part of the monthly fee.",
  },
  {
    q: "What does the $499 build include, and how many revisions do I get?",
    home: true,
    a: "The standard build is up to five standard pages, with the exact page list and scope agreed before work begins — a one-page website is also fine when that suits the business. You get two consolidated revision rounds before launch; fixing errors in our own work never counts toward those rounds. Additional pages, major changes to the approved direction, advanced features, and custom integrations are quoted separately before we proceed.",
  },
  {
    q: "What happens to my website if I cancel?",
    home: true,
    a: "Cancellation takes effect at the end of your current billing cycle. The hosted website is then deactivated and we keep a backup for 30 days in case you change your mind. Your text and image content can be exported on request, and your domain can be transferred to you once the account is settled. The underlying website code and platform aren't part of that export.",
  },
  {
    q: "How do I find out about new quote requests?",
    home: false,
    a: "Quote and contact form submissions are emailed to you and tracked in your client portal. If you'd rather get a text the moment a request comes in, that's an optional automation we quote individually — as are automatic acknowledgments to your customer and missed-call text backs.",
  },
  {
    q: "How long does it take to get my website live?",
    home: false,
    a: "Most first drafts are ready within a few business days after we have your business information and content. Launch timing depends on revisions and your approval.",
  },
  {
    q: "Do I need to manage anything myself?",
    home: false,
    a: "No. WebJesters builds, hosts, maintains, and supports the site. You can update your own business info, hours, services, and photos through the client portal any time and those changes go straight to your website, but you never have to touch hosting, plugins, or code.",
  },
  {
    q: "Who gets portal access?",
    a: "The client portal is included when WebJesters builds your website. Local Visibility-only customers don't receive portal access — we handle your profiles and send you a monthly summary by email instead.",
  },
  {
    q: "Who owns my domain and content?",
    home: true,
    a: "You own the content you give us — your business name, logo, photos, and copy. Domains we manage on your behalf are associated with your business and can be transferred to you on request once your account is settled.",
  },
  {
    q: "What is Local Visibility?",
    lv: true,
    a: "Local Visibility is a standalone monthly service that keeps your Google Business Profile active and your social presence consistent. It's $149 one-time onboarding for initial Google Business Profile setup or cleanup, then $299/month for Google plus one included social platform (Facebook or Instagram), or $348/month for both. You don't need a WebJesters website to use it — it works just as well if your site is hosted elsewhere, or if you don't have a website at all. It's billed separately from the website plan, and ending one doesn't affect the other.",
  },
  {
    q: "What does the $299/month Local Visibility plan include?",
    lv: true,
    a: "Four content pieces per month created from photos or clips you provide. We prepare your photos and short clips for posting, with captions, simple branding, and light edits where needed. Each piece is published to both your Google Business Profile and one included social platform — up to four posts on each platform, eight placements in total — plus basic profile upkeep and a short monthly email summary listing the posts we published with links, the profile info we updated, and what we need from you next month.",
  },
  {
    q: "Which social platforms do you support, and what does a second one cost?",
    lv: true,
    a: "At launch we support Facebook Pages and Instagram professional accounts. You choose one as your included platform: Google Business Profile + Facebook is $299/month, Google Business Profile + Instagram is $299/month, and all three together is $348/month. The second platform gets the same four prepared pieces, adapted for that platform — captions, sizing, scheduling, and publishing — not four additional unique pieces. We only bill for it once that account's access is ready and posting can begin.",
  },
  {
    q: "What is not included in Local Visibility?",
    lv: true,
    a: "Filming or photo shoots, comment or inbox management, review replies, paid advertising, separate original content campaigns for each platform, and elaborate custom design, extensive video editing, animation, or multiple creative versions of a post. Content is created from the photos and clips you send us, and you keep ownership of your Google Business Profile and social accounts — we work through manager access you grant and can remove any time.",
  },
  {
    q: "Do you design or edit the posts?",
    lv: true,
    a: "Lightly, where it helps. Depending on the material, we may add a simple text overlay or your logo, crop the photo, put together a basic before-and-after layout, or trim a short clip. Not every post needs graphics or editing — many go out as a clean original photo with a good caption. We don't promise elaborate custom designs, extensive video editing, animation, or multiple creative versions. Each prepared piece is adapted for every platform you've included, and your original files are always kept untouched.",
  },
  {
    q: "I already paid for the $299 Google Business Profile setup. Do I pay the $149 onboarding again?",
    lv: true,
    gbp: true,
    home: true,
    a: "No. It's the same setup work either way — $299 buys it on its own, and $149 is the onboarding rate when you start the monthly Local Visibility plan. If you completed the standalone $299 setup, the $149 onboarding fee is waived when you add Local Visibility, provided no substantial new setup work is required. Enter the same email you used for the setup and the waiver is applied automatically; if you used a different email, send us an inquiry and we'll apply it manually.",
  },
  {
    q: "How do I send you photos and updates?",
    lv: true,
    a: "Text or email them any time. To keep photo and video quality, send originals by email or a download link such as Google Drive, Dropbox, or iCloud — regular text attachments get compressed. We keep your originals untouched — any light edits and platform-sized versions are made on copies. We prepare each post and send it to you for approval before anything is published.",
  },
  {
    q: "What happens if I don't send content one month?",
    lv: true,
    a: "Unused content pieces don't roll over when we don't have the photos or approvals needed to publish. If WebJesters misses a piece that was included, that work still stays owed to you.",
  },
  {
    q: "Is the $149 onboarding fee refundable?",
    lv: true,
    a: "Yes, before work begins. Once setup or cleanup starts it becomes non-refundable. Google approval or verification is never guaranteed — that decision belongs to Google.",
  },
  {
    q: "Can I add, switch, or remove a social platform later?",
    lv: true,
    a: "Yes. Platform additions, switches, and removals take effect starting with the next billing month. For additions or switches, we need manager access to the new account before that month begins.",
  },
  {
    q: "What does the Google Business Profile setup or cleanup cover?",
    gbp: true,
    home: true,
    a: "It's a one-time service, $299 per location, with no subscription and no website purchase required. We either create a new profile or audit, clean up, and complete the one you have: business details, hours, contact information, website links, service areas, primary and secondary category research, your business description and services, your logo, cover image, and photos, a review-request link, verification guidance when Google requires it, and a brief completion summary when we're done.",
  },
  {
    q: "Do you need my Google password?",
    gbp: true,
    a: "Never. You keep ownership of your Google Business Profile and add WebJesters as a manager from your own account — we'll walk you through it. You can remove that access at any time.",
  },
  {
    q: "Will my profile get verified, and will it rank?",
    gbp: true,
    a: "Verification is decided by Google, may require your participation (a video, postcard, or phone call), and isn't something we can guarantee. We also don't guarantee rankings or leads. What we do guarantee is a complete, accurate, well-categorized profile with everything Google asks for in place.",
  },
  {
    q: "My profile is suspended or there's a duplicate listing. Is that included?",
    gbp: true,
    a: "Suspension appeals, ownership disputes, and complicated duplicate-listing issues need a separate assessment and quote, because the work and the timeline depend entirely on the situation. Tell us what's going on in your inquiry and we'll give you an honest read before you pay anything.",
  },
  {
    q: "Is the Google Business Profile setup a subscription?",
    gbp: true,
    a: "No. It's a single $299 payment per location, and nothing recurring is created. If you later want it kept active with monthly posting, that's our separate Local Visibility service — and your $149 onboarding fee is waived because the setup is already done.",
  },
  {
    q: "Can I cancel?",
    lv: true,
    gbp: true,
    home: true,
    a: "Yes. Both the website plan and Local Visibility are month-to-month with no long-term contract. Email team@webjesters.com and cancellation takes effect at the end of your current billing cycle. The Google Business Profile setup is a one-time purchase, so there's nothing to cancel.",
  },
  {
    q: "When are you available?",
    rev: true,
    lv: true,
    gbp: true,
    a: "Monday through Friday, 9:00am to 5:00pm Arizona time. We reply to every inquiry within one business day.",
  },
  {
    q: "Where does WebJesters work?",
    rev: true,
    lv: true,
    a: "WebJesters is based in Arizona and works with local service businesses anywhere in the United States. Everything is handled remotely — no on-site visits needed.",
  },
];

export const HOME_FAQS = FAQS.filter((f) => f.home);

export const faqJsonLd = (items = FAQS) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
});
